export const BASIC_OPERATION_PERMISSIONS = [
  'VISUALIZAR_CLIENTE',
  'VISUALIZAR_GRUPO',
  'VISUALIZAR_CATALOGO_SERVICO',
  'VISUALIZAR_AGENTE',
  'VISUALIZAR_TIPO_TICKET',
  'VISUALIZAR_EMPRESA',
  'CRIAR_TICKET',
  'CRIAR_TICKET_POR_PRE_TICKET',
  'VISUALIZAR_TICKET',
  'EDITAR_TICKET',
  'REABRIR_TICKET',
  'VISUALIZAR_PRE_TICKET',
  'VISUALIZAR_DASHBOARD_TICKET',
  'VISUALIZAR_CONTATO',
  'CADASTRAR_CONTATO',
  'EDITAR_CONTATO',
  'VISUALIZAR_SLA',
  'VISUALIZAR_MOTIVO_PAUSA',
  'PAUSAR_RETOMAR_SLA',
  'VISUALIZAR_ATIVOS',
  'VISUALIZAR_ALERTAS',
  'VISUALIZAR_TAREFAS',
  'CRIAR_KB_GRUPOS',
  'EDITAR_KB_GRUPOS',
  'VISUALIZAR_KB_GRUPOS',
  'CRIAR_KB_PASTAS',
  'EDITAR_KB_PASTAS',
  'MOVIMENTAR_EM_LOTE_KB_PASTAS',
  'VISUALIZAR_KB_PASTAS',
  'CRIAR_ARTIGOS',
  'MOVIMENTAR_EM_LOTE_ARTIGOS',
  'EDITAR_ARTIGOS',
  'VISUALIZAR_ARTIGOS',
  'CRIAR_TAGS',
  'EDITAR_TAGS',
  'VISUALIZAR_TAGS',
  'VISUALIZAR_PRODUTO_SERVICO',
  'VISUALIZAR_PRODUTOS_LANCADOS',
  'VISUALIZAR_MODELO_MENSAGEM',
  'CADASTRAR_APONTAMENTO',
  'EDITAR_APONTAMENTO',
  'VISUALIZAR_APONTAMENTO'
];

export const INTERMEDIATE_OPERATION_PERMISSIONS = [
  ...BASIC_OPERATION_PERMISSIONS,
  // Clientes / Contatos
  'CADASTRAR_CLIENTE',
  'EDITAR_CLIENTE',
  'IMPORTAR_CLIENTES',
  'IMPORTAR_CONTATOS',
  // Catálogo / Tipos
  'CADASTRAR_CATALOGO_SERVICO',
  'EDITAR_CATALOGO_SERVICO',
  'IMPORTAR_CATALOGO_SERVICO',
  'CADASTRAR_TIPO_TICKET',
  'EDITAR_TIPO_TICKET',
  // Tickets / Pré-tickets
  'REMOVER_PRE_TICKET',
  'BLOQUEAR_REMETENTE',
  'LIBERAR_REMETENTE',
  // Ativos
  'CADASTRAR_ATIVOS',
  'EDITAR_ATIVOS',
  'VISUALIZAR_TIPOS_ATIVOS',
  'CADASTRAR_TIPOS_ATIVOS',
  'EDITAR_TIPOS_ATIVOS',
  // SLA
  'CADASTRAR_MOTIVO_PAUSA',
  'EDITAR_MOTIVO_PAUSA',
  // Tarefas
  'CRIAR_TAREFAS',
  'EDITAR_TAREFAS',
  'EDITAR_EM_LOTE_TAREFAS',
  // Conhecimento
  'PUBLICAR_DESPUBLICAR_ARTIGOS',
  // Relatórios
  'VISUALIZAR_RELATORIO_EXECUTIVO_CLIENTE',
  'VISUALIZAR_RELATORIO_VISAO_GERAL',
  'VISUALIZAR_RELATORIO_PRODUTIVIDADE',
  // Produtos / Lançamentos
  'ASSOCIAR_PRODUTO_TICKET',
  'EDITAR_PRODUTOS_LANCADOS'
];

export const ADVANCED_OPERATION_PERMISSIONS = [
  ...INTERMEDIATE_OPERATION_PERMISSIONS,
  // Perfis e Usuários
  'VISUALIZAR_PERFIL',
  'CADASTRAR_PERFIL',
  'EDITAR_PERFIL',
  'CADASTRAR_AGENTE',
  'EDITAR_AGENTE',
  // VISUALIZAR_AGENTE already in basic
  'RESETAR_SENHA',
  // Estrutura do Sistema
  'CADASTRAR_GRUPO',
  'EDITAR_GRUPO',
  'CADASTRAR_CAIXA_EMAIL',
  'EDITAR_CAIXA_EMAIL',
  'REMOVER_CAIXA_EMAIL',
  // SLA
  'EDITAR_SLA',
  'EXCLUIR_SLA',
  // Tickets / Pré-tickets
  'REMOVER_TICKET',
  'REMOVER_EM_LOTE_PRE_TICKET',
  // Ativos
  'EXCLUIR_PROPRIEDADES_CUSTOMIZADAS',
  'MAPEAR_PROPRIEDADES_CUSTOMIZADAS',
  'MAPEAR_TIPOS_ATIVOS',
  // Conhecimento
  'REMOVER_KB_GRUPOS',
  'REMOVER_KB_PASTAS',
  'REMOVER_ARTIGOS',
  'REMOVER_TAGS',
  'REMOVER_EM_LOTE_TAGS',
  // Tarefas
  'EXCLUIR_TAREFAS',
  // Relatórios Personalizados
  'VISUALIZAR_RELATORIO_PERSONALIZADO',
  'CADASTRAR_RELATORIO_PERSONALIZADO',
  'EDITAR_RELATORIO_PERSONALIZADO',
  'EXECUTAR_RELATORIO_PERSONALIZADO',
  'EXPORTAR_RELATORIO_PERSONALIZADO',
  'EXCLUIR_RELATORIO_PERSONALIZADO',
  // APIs e Integrações
  'VISUALIZAR_API_CREDENCIAIS',
  'CADASTRAR_API_CREDENCIAIS',
  'EDITAR_API_CREDENCIAIS',
  'EXCLUIR_API_CREDENCIAIS',
  'VISUALIZAR_CHAVE_API',
  'CADASTRAR_CHAVE_API',
  'EDITAR_CHAVE_API',
  'REMOVER_CHAVE_API',
  // Faturamento
  'GERAR_FATURA',
  'EDITAR_FATURA',
  'ALTERAR_STATUS_FATURA',
  'EXPORTAR_FATURA',
  'REMOVER_ITENS_FATURA'
];
